export default __webpack_public_path__ + "static/media/sort_asc.12d46637.webp";